import { sendGet, sendPost, sendDelete, type Response } from '../../hooks/use-fetch'
import {
  type EmailBatchParseResult,
  type InvitationDto,
  type SendInvitationsRequest,
  type SendInvitationsResult
} from '../../models/peerToPeer/Invitations'

export async function ValidateInvitationEmails (raw: string): Promise<Response<EmailBatchParseResult>> {
  return await sendPost('PeerToPeer/Invitations/Validate', { raw })
}

export async function SendInvitations (request: SendInvitationsRequest): Promise<Response<SendInvitationsResult>> {
  return await sendPost('PeerToPeer/Invitations', request)
}

export async function ListInvitations (isdOrganizationId: number, reportingYearId: number): Promise<Response<InvitationDto[]>> {
  return await sendGet(`PeerToPeer/Invitations?isdOrganizationId=${isdOrganizationId}&reportingYearId=${reportingYearId}`)
}

export async function ResendInvitation (invitationId: number): Promise<Response<unknown>> {
  return await sendPost(`PeerToPeer/Invitations/${invitationId}/Resend`, {})
}

export async function RevokeInvitation (invitationId: number): Promise<Response<unknown>> {
  return await sendDelete(`PeerToPeer/Invitations/${invitationId}`)
}
